import { useState } from 'react';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { SuccessForgotModal } from './widgets';
import { Footer } from '@widgets/footer';
import { Input } from '@shared/widgets/inputs';
import { Button } from '@shared/widgets';
import bgImg from '@assets/images/auth/bg-02.png';
import { Controller, useForm } from 'react-hook-form';

interface IFormData {
  email: string;
  cardNumber: string;
}

export const ForgotPage = () => {
  const formControl = useForm({
    mode: 'onChange',
    defaultValues: {
      email: '',
      cardNumber: '',
    } as IFormData,
  });

  const [loader] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [emailError, setEmailError] = useState('');
  const [cardNumberError, setCardNumberError] = useState('');
  const [, setErrorValidate] = useState(false);

  const { navigate } = useRouteHook();

  const sendForm = (data: IFormData) => {
    if (validateField('email', data.email) && validateField('cardNumber', data.cardNumber)) {
      setIsShowModal(true);
    }
  };

  const validateField = (fieldName: string, value: string) => {
    let error = false;
    let text = '';

    switch (fieldName) {
      case 'email':
        if (value.length < 1) {
          text = 'incorrect email';
          error = true;
        }
        break;
      case 'cardNumber':
        if (value.length < 1) {
          text = 'incorrect cardnumber';
          error = true;
        }
        break;
    }

    if (fieldName === 'email') {
      setEmailError(text);
    } else if (fieldName === 'cardNumber') {
      setCardNumberError(text);
    }
    setErrorValidate(error);

    return !error;
  };

  return (
    <>
      <div className='mx-auto flex h-[702px] max-w-[1440px] overflow-hidden max-md:relative max-md:z-[1] max-md:h-auto max-md:w-full max-md:flex-col-reverse'>
        <div className='relative z-[99] w-[140px] max-md:hidden' />
        <div
          className='relative z-[99] h-[702px] w-full bg-right bg-no-repeat pl-[150px] text-left max-md:h-auto max-md:!bg-none max-md:pt-0 max-md:pl-0'
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <form
            className='w-[590px] max-md:relative max-md:w-full max-md:px-4 max-md:pt-5 max-md:pb-12'
            onSubmit={formControl.handleSubmit(sendForm)}
          >
            <h2 className='mt-[103px] font-[Prata] text-[56px] text-[#272727] max-md:mt-0 max-md:text-center max-md:text-[28px]'>
              Password Recovery
            </h2>
            <p className='mt-2 mb-7.5 text-lg font-light text-[#4c4c4c] before:absolute before:left-0 before:mt-[15px] before:h-[1px] before:w-[125px] before:bg-[#000] max-md:text-center max-md:text-[#4c4c4c80] max-md:before:hidden'>
              Enter the world of Insignia
            </p>
            <div className='mt-2 flex items-center gap-2 max-md:mt-4 max-md:block'>
              <Controller
                name='email'
                control={formControl.control}
                rules={{
                  maxLength: 100,
                }}
                render={({ field: { value, onChange }, fieldState: { error } }) => (
                  <>
                    <Input inputClassName='w-[292px]' label='Email Address' name='email' value={value} onChange={onChange} />
                    {error && (
                      <div className='mt-8 flex items-baseline gap-1 max-md:hidden'>
                        <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                        <div className='text-xs font-bold text-[#d0021b] uppercase'>{emailError}</div>
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className='mt-2 flex items-center gap-2 max-md:mt-4 max-md:block'>
              <Controller
                name='cardNumber'
                control={formControl.control}
                rules={{
                  maxLength: 100,
                }}
                render={({ field: { value, onChange }, fieldState: { error } }) => (
                  <>
                    <Input inputClassName='w-[292px]' label='Card Number' name='cardNumber' value={value} onChange={onChange} />
                    {error && (
                      <div className='mt-8 flex items-baseline gap-1 max-md:hidden'>
                        <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                        <div className='text-xs font-bold text-[#d0021b] uppercase'>{cardNumberError}</div>
                      </div>
                    )}
                  </>
                )}
              />
            </div>
            <div className='mt-4'>
              <span className='cursor-pointer font-medium text-[#000000]' onClick={() => navigate(RoutePaths.recovery.onNavigate())}>
                Forgotten your password?
              </span>
            </div>
            <div className='mt-5 flex gap-4 max-md:mt-8'>
              <Button className='w-[138px] max-md:w-full' color='outlined' onClick={() => navigate(RoutePaths.login.onNavigate())}>
                Cancel
              </Button>
              <Button className='w-[138px] max-md:w-full' isLoading={loader} onClick={formControl.handleSubmit(sendForm)}>
                Next
              </Button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
      <SuccessForgotModal isOpen={isShowModal} onClose={() => setIsShowModal(false)} />
    </>
  );
};
